export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type Optionalize<T extends K, K> = Omit<T, keyof K>;
export type WithOptional<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

/**
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 * Cleanly and safely narrow the type without forcing the type
 *
 * example :
 * const result = ['a', 'b', undefined].filter(isDefined); // type is `string[]`
 * const result = ['a', 'b', undefined].filter(v=> v !== undefined); // type is `(string | undefined)[]`
 */
export function isDefined<T>(v: T | undefined): v is T {
  return v !== undefined;
}
